import styled from 'styled-components'
import { TitleValueBlockV2 } from 'Layout'
import AppButton from 'Components/AppButton'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import { CLICKABLE_COLOR, TEXT_GREY } from '@CSSVars/colors'


export const _ListingDetailKeyContainer = styled.div`
  display: flex;
  flex-direction: column;
  //padding: 24px 0 0;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
  }
`

export const _FactsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  margin-top: -32px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 0;
    flex-direction: column;
  }
`

export const _Fact = styled.div`
  width: 33%;
  padding-top: 33px;
  display: flex;
  flex-direction: row;
  gap: 25px;
  align-items: center;
  ${({ isAmenities, showAmenities }) => (
    (isAmenities && showAmenities) ? `
        cursor: pointer
    ` : 'cursor: default')};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    gap: 32px;
    width: 100%;
    padding-top: 25px;
    &:first-child {
      padding-top: 0;
    }
    ${({ isAmenities }) => (
    isAmenities ? `
        display: none;
    ` : '')};
  }
`

export const _FactText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 17.07px;
  text-align: left;
  a {
    color: ${({ showAmenities }) => (showAmenities ? CLICKABLE_COLOR : TEXT_GREY)};
  }
`

export const _SvgContainer = styled.div`


`

export const _ViewBuildingAmenities = styled(AppButton)`
  display: flex;
  width: 100%;
  margin-top: 32px;
  height: 44px;
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _TitleValueBlock = styled(TitleValueBlockV2)`
  margin: -5px 0;
  width: 25%;
  &:first-child {
    margin-bottom: 21px!important;
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 24px;
    width: 50%;
  }
`

